import {useState} from 'react'
import axios, {AxiosResponse} from 'axios'
import endpoints from '../endpoints'

const API_URL = process.env.REACT_APP_API_URL || ''

export interface FileUploadResponse {
  // Define the structure of the response data returned from the API
  data: string
  status: boolean
  message: string
}

export const useFileUpload = () => {
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [uploadProgress, setUploadProgress] = useState<number>(0)

  const uploadFile = async (file: File): Promise<FileUploadResponse> => {
    try {
      if (!file) {
        throw 'Please provide the file'
      }
      setIsUploading(true)

      const formData = new FormData()
      formData.append('file', file)

      const response: AxiosResponse<FileUploadResponse> = await axios.post(
        API_URL + endpoints.fileUpload.upload,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent: ProgressEvent) => {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            setUploadProgress(progress)
          },
        }
      )

      return response.data
    } catch (error: unknown) {
      console.error('Error sending message:', error)
      throw error
    } finally {
      setIsUploading(false)
      setUploadProgress(0)
    }
  }

  return {uploadFile, isUploading, uploadProgress}
}
